import React from 'react'
import HistoryReturnPage from '../../modules/cassier/HistoryReturnPage'

const HistoryReturn = () => {
    return (
        <HistoryReturnPage></HistoryReturnPage>
    )
}

export default HistoryReturn